<template>
  <div >
    <h3>Clusters / Destination / Calls</h3>
    <p>Find out how large different portions of Horizon Europe are with respect to number of funding topics, and navigate to the parts of most interest to you.</p>
    <v-chart v-if="this.horizonTreemap" class="chart" :option="options" v-on:click="triggerSearch" ref="treemap" autoresize/>

  </div>
</template>

<script>
import {
  use
} from "echarts/core";
import {
  CanvasRenderer
} from "echarts/renderers";
import {
  TreemapChart
} from "echarts/charts";

import {
  TooltipComponent,
} from "echarts/components";

import VChart, {
  THEME_KEY
} from "vue-echarts";

use([
  CanvasRenderer,
  TreemapChart,
  TooltipComponent
]);

export default {
  name: 'InfoGraphicsTreemap',
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  },
  computed: {
    horizonTreemap () {
      return this.$store.state.horizonTreemap;
    },
    options () {
      if( this.$store.state.horizonTreemap ) {
        chartOptions.series[0].data = this.horizonTreemap[0].children;
        return chartOptions;
      }
      return null;
    }
  },
  created: function () {
  //if( this.horizonTreemap == null || this.horizonTreemap == '' ) {
      this.$store.dispatch('fetchHorizonTreemap');
  //}
  },
  data() {
    return {
    }
  },
  methods: {
    triggerSearch: function(e) {
      if( e.data.sem_url ) {
        this.$router.push({path: '/'+ e.data.sem_url });
      }
    },
  },
}

var chartOptions = {
        tooltip: {
          formatter: function(params) {
            var data = params.data;
            return '<div style="max-width:350px;white-space: break-spaces;">'+data.id+'</br>'+data.name+'</br>'+data.value+' Topics'+'</div>'
          }
        },
        series: [{
          name: 'Start',
          type: 'treemap',
          nodeClick: 'zoomToNode',  //have added a link on Horizon.1.1. -> remove it after testing
          visibleMin: 300, //unit: px square
          roam: false, // prevent scroll wheel from zoom/move
          data: null,
          leafDepth: 1, // represents how many levels are shown at most. In my opinion leafDepth=1 is the easiest to grasp
          breadcrumb: {
            top: 0,
            show: true, // default. Shows the path of the selected component at the bottom of the screen
            itemStyle: {
              textStyle: {
                overflow: 'truncate'
              }
            }
          },
          levels: [
            {
              itemStyle: {
                  borderColor: '#555',
                  borderWidth: 4,
                  gapWidth: 4
              },
              color: ['#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#5470c6']
            },
            {
              colorSaturation: [0.4, 0.6],
              itemStyle: {
                  borderColorSaturation: 0.7,
                  gapWidth: 2,
                  borderWidth: 2
              }
            },
            {
              colorSaturation: [0.4, 0.6],
              itemStyle: {
                  borderColorSaturation: 0.7,
                  gapWidth: 1
              }
            },
            {
              colorSaturation: [0.4, 0.6] // if there are more levels than this, the configuration of the lower defined level are used for the lower ones
            }
          ]
        }]
      }
</script>

<style scoped>
  .chart {
    width: 95%;
    height: 500px;
  }
</style>
